var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBell(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.99992 16.5C9.82492 16.5 10.4999 15.825 10.4999 15H7.49992C7.49992 15.825 8.16742 16.5 8.99992 16.5ZM13.4999 12V8.25C13.4999 5.9475 12.2699 4.02 10.1249 3.51V3C10.1249 2.3775 9.62242 1.875 8.99992 1.875C8.37742 1.875 7.87492 2.3775 7.87492 3V3.51C5.72242 4.02 4.49992 5.94 4.49992 8.25V12L3.53242 12.9675C3.05992 13.44 3.38992 14.25 4.05742 14.25H13.9349C14.6024 14.25 14.9399 13.44 14.4674 12.9675L13.4999 12Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBell);
export default __webpack_public_path__ + "static/media/bell.3d03f0afcfd8d6e7cf523f5a5a540e83.svg";
export { ForwardRef as ReactComponent };